/* istanbul ignore file */ /* this file is not used or will be deleted in other branches */
// @ts-nocheck
import componentTypes from '@data-driven-forms/react-form-renderer/dist/cjs/component-types';
import {
  ControlsRowWrapper,
  DatePickerDdf,
  DateInputDdf,
  FieldArray,
  GridCell,
  LabelField,
  MaskedTextFieldDdf,
  PlainTextDDF,
  PlainTextArray,
  SelectDdf,
  TextFieldDdf
} from '@td-client-frontend/common';

import { ButtonDDf, ButtonWithIconDDf } from '../Button';
import { CheckboxGrid } from '../form-controls/CheckboxGrid';
import FieldSelectArray from '../form-controls/FieldSelectArray';
import Grid from '../form-controls/Grid';
import LoadMore from '../form-controls/LoadMore';
import { MultiInputDdf } from '../form-controls/MultiInput';
import { Tabs } from '../Tabs';
import { Handler } from '../form-controls/Handler';
import { FileUploadDdf } from '../form-controls/FileUpload';
import { Checkbox } from '../form-controls/Checkbox';
import RadioButton from '../form-controls/RadioButton';
import ErrorWithIcon from '../form-controls/ErrorWithIcon';

export const customComponentTypes = {
  ...componentTypes,
  DATE_INPUT: 'date-input',
  MULTI_INPUT: 'multi-input',
  GRID_CELL: 'grid-cell',
  FIELD_ROW: 'row',
  FIELD_GRID: 'grid',
  FIELD_LABEL: 'label',
  FILE_UPLOAD: 'file-upload',
  MASKED_TEXT_FIELD: 'masked-text-field',
  CHECKBOX_GRID: 'checkbox-grid',
  LOAD_MORE: 'load-more',
  FIELD_SELECT_ARRAY: 'field-select-array',
  HANDLER: 'handler',
  GROUP_SEARCH_SELECT: 'group-search-select',
  MEMBER_DEPENDENTS_TABLE: 'member-dependents-table',
  BUTTON_WITH_ICON: 'button-with-icon',
  ERROR_WITH_ICON: 'error-with-icon'
};

const componentsMapper = {
  [customComponentTypes.TEXT_FIELD]: TextFieldDdf,
  [customComponentTypes.MASKED_TEXT_FIELD]: MaskedTextFieldDdf,
  [customComponentTypes.SELECT]: SelectDdf,
  [customComponentTypes.DATE_PICKER]: DatePickerDdf,
  [customComponentTypes.DATE_INPUT]: DateInputDdf,
  [customComponentTypes.FILE_UPLOAD]: FileUploadDdf,
  [customComponentTypes.TABS]: Tabs,
  [customComponentTypes.RADIO]: RadioButton,
  [customComponentTypes.CHECKBOX]: Checkbox,
  [customComponentTypes.CHECKBOX_GRID]: CheckboxGrid,
  [customComponentTypes.FIELD_ARRAY]: FieldArray,
  [customComponentTypes.FIELD_SELECT_ARRAY]: FieldSelectArray,
  [customComponentTypes.PLAIN_TEXT]: PlainTextDDF,
  [customComponentTypes.MULTI_INPUT]: MultiInputDdf,
  [customComponentTypes.GRID_CELL]: GridCell,
  [customComponentTypes.FIELD_ROW]: ControlsRowWrapper,
  [customComponentTypes.FIELD_GRID]: Grid,
  [customComponentTypes.BUTTON]: ButtonDDf,
  [customComponentTypes.FIELD_LABEL]: LabelField,
  [customComponentTypes.LOAD_MORE]: LoadMore,
  [customComponentTypes.HANDLER]: Handler,
  [customComponentTypes.BUTTON_WITH_ICON]: ButtonWithIconDDf,
  [customComponentTypes.ERROR_WITH_ICON]: ErrorWithIcon
};

const fieldWrapperTypes = {
  [componentTypes.TABS]: Tabs,
  [componentTypes.FIELD_ARRAY]: PlainTextArray,
  [customComponentTypes.FIELD_ROW]: ControlsRowWrapper,
  [customComponentTypes.BUTTON_WITH_ICON]: ButtonWithIconDDf
};

export const plainTextMapper = Object.keys(componentsMapper).reduce((mapper, componentType) => {
  return {
    ...mapper,
    // use plain text unless another component is specified in diff.
    [componentType]: fieldWrapperTypes[componentType] || PlainTextDDF
  };
}, {});

export default componentsMapper;
